module.exports = __webpack_public_path__ + "media/bom/substitute-part-3020f5a8.png";